module.exports = __webpack_public_path__ + "img/miccai2025-logo.cada6a69.png";